module.exports = __webpack_public_path__ + "img/step_2.36b29337.svg";